<template>
<!--  -->
<Window :title="title" :hideBtn="true" :hideBtnText="$t('cmd85',['取消'])" @Close="onClose" @Closed="onClosed" ref="Window">
	<button slot="headButton" class="functionBtn pl1x pr1x" v-debounce:click="save" type="button">{{$t('cmd84',['保存'])}}</button>
	<div class="w50pct mc">
		<div class="tableSys vaT_E">
			<div class="w30pct">
				<div class="taC">
					<AddFile class="w100pct"
						:picMode="'free'"
						:removeBtn="false"
						:toolDisplay="false"
						:file="data.url"
						:verification="'notEmpty:'+$t('fill3rd145',[$t('plant_detail12'),'照片不能为空'])"
						:accept="'.jpg,.gif,.png,.jpeg'"
						:maxSize="1024*1024*2"
						:text="$t('plant_detail13',['点击这里上传照片'])"
						@Select="file=>{photo=file}"
						@Upload="onUpload"
						ref="AddFile"
					></AddFile>
				</div>
				<div class="mt2x cSub lh15">{{$t('plant_detail15',['JPG/GIF/PNG/JPEG','2M','支持图片格式：JPG/GIF/PNG/JPEG，文件小于2M'])}}</div>
			</div>
			<div class="w2x"></div>
			<div>
				<div class="cSub"><span class="cError">*</span>{{$t('word909',['标题'])}}</div>
				<InputText v-model="data.name" class="mt05x" :verification="'notEmpty'" :maxLength="100" ref="name"></InputText>

				<div class="cSub mt2x">{{$t('word702',['描述'])}}</div>
				<textarea v-model="data.description" class="w100pct h20x mt05x bdSub tra-fast" maxlength="2000"></textarea>
			</div>
		</div>
	</div>
</Window>
</template>
<script>
import * as lib from '@/util/lib';

import Window from '@/components/common/ui/WindowForNew.vue';
import InputText from '@/components/common/ui/InputText.vue';
import AddFile from '@/components/common/ui/AddFile.vue';

import {apiNewPhoto,apiEditPhoto,apiDeletePhoto} from '@/api/maintain/plant/list';
export default{
	// name:"",
	components:{Window,InputText,AddFile},
	props:{
		plantId:{//所属电站ID
			type:Number,
			default:undefined
		},
		addClass:{//激活的索引项
			type:[String,Object],
			default:""
		},
	},
	data(){
		return{
			dynamic:null,
			mode:"new",//edit
			lock:false,
			saved:false,//保存过则通过此属性告知外部

			data:{
				powerStationId:this.plantId,
				name:"",
				description:"",
				url:""
			},
			photo:null
		}
	},
	watch:{},
	methods:{
		getLanguageStr,
		reset:function(){
			this.data={};
			this.lock=false;
		},
		show:function(data,dynamic){
			if(dynamic) this.dynamic=dynamic;
			if(data=="new"){
				this.mode="new";
				this.reset();
			}
			else{
				this.mode="edit";
				this.data=$.extend(true,{},data);
				this.photo=this.data.url;
			}
			this.lock=false;

			this.$refs.Window.show();
		},
		onClose:function(){
			this.$emit("Close",this.saved);
		},
		onClosed:function(){
			if(this.dynamic) this.dynamic.destroyUi();
		},
		onUpload:function(photo){
			// this.photo=photo.file;
			this.data.url=photo.file.src;
		},
		save:function(){//保存操作
			let allClear = true
			$.each(this.$refs,function () {
				if (this && this.verification) { // 有时候某些组件隐藏掉会导致this为undefined
					let clear = this.doVerification()
					if (allClear) allClear = clear
				}
				// if(allClear==false) return false;
			});
			if(allClear){
				this.lock=true;
				switch(this.mode){
					case "new":
						this.lock=true;
						this.data.powerStationId=this.plantId;
						apiNewPhoto(this.data).then(success=>{
							this.saved=true;
							this.$refs.Window.hide();
						},
						error=>{
							this.lock=false;
						});
						break;
					case "edit":
						apiEditPhoto(this.data).then(success=>{
							this.$emit("Update",this.data);
							this.$refs.Window.hide();
						},
						error=>{
							this.lock=false;
						});
						break;
				}
			}
		}
	},
	computed:{
		title:function(){
			if(this.mode=="new") return getLanguageStr('plant_detail14','添加新照片');
			else return i18n.t('fill3rd143',[getLanguageStr('plant_detail12'),'编辑照片']);
		}
	},
	created(){},
	mounted(){
		lib.fillHeight();
	},
	destroyed(){}
}
</script>
<style lang="scss" scoped>
// .photo{position:relative;
// 	>*{position:absolute;top:0;left:0;}
// }
</style>


// WEBPACK FOOTER //
// src/components/common/viewPhoto/NewEdit.vue